import $j from 'jquery';
import { config } from '../../config/Config';
import { IsNumeric, xmlToJson, getCoordinates } from '../Utils/FormatUtils';
import GeoJSON from 'ol/format/GeoJSON';
import { toast } from 'react-toastify';

import { getTranslatedKey } from '../Utils/TranslateUtils';

let $llamada; // guardamos la llamada en una variable para detectar las siguientes llamadas y cancelar la actual

/**
 *
 * @param {*} addCercaToponim
 * @param {*} clearArElements
 * @param {*} zoomCoord
 * @param {*} search
 * @param {*} handleLoadingLoc
 * @desc funció per cridar al servei de geocodificació de l'ICGC per obtenir coordenades, pks, carrers o toponims
 */
export async function cercaElements(addCercaToponim, clearArElements, zoomCoord, search, handleLoadingLoc, closeCerca, isAvançada) {
  //abortem la crida anterior si hi ha una de nova
  if ($llamada != null) {
    $llamada.abort();
    $llamada = null;
  }
  //comprovem que el text entrat no es buit
  const isValidSearch = search !== undefined && search !== '' && search !== null;
  if (!isValidSearch) return;

  const searchTerm = search.replace(/:/g, '\\:');

  const coord = getCoordinates(searchTerm);
  if (coord) {
    centerAtCoord(coord, zoomCoord);
    return;
  }

  //mostrem el spinner de loading y netegem l'array d'elements
  handleLoadingLoc(true);
  clearArElements();

  // si la cerca no es de coordenades, busquem els elements i capes
  let cercaValue = getCercaValue(searchTerm);
  let post, action;

  if (cercaValue === 4) {
    //punt quilometric
    post = getPostPK(searchTerm);
    action = 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaPK';
    ajaxCall('PK', post, action, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, closeCerca, isAvançada);
  } else if (cercaValue === 3) {
    //adreça
    post = getPostAddress(searchTerm);
    action = 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaAdreca';
    ajaxCall('Address', post, action, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, undefined, isAvançada);
  }
  if (cercaValue === 2 || cercaValue === 100) {
    //toponim
    post = getPostToponym(searchTerm);
    action = 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaToponim';
    ajaxCall('Toponym', post, action, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, undefined, isAvançada);
  }
}

export async function cercaAdreça(addCercaToponim, clearArElements, zoomCoord, search, handleLoadingLoc) {
  //abortem la crida anterior si hi ha una de nova
  if ($llamada != null) {
    $llamada.abort();
    $llamada = null;
  }

  //comprovem que el text entrat no es buit
  const isValidSearch = search !== undefined && search !== '' && search !== null;
  if (!isValidSearch) return;

  const searchTerm = search.replace(/:/g, '\\:');

  //mostrem el spinner de loading y netegem l'array d'elements
  handleLoadingLoc(true);
  clearArElements();

  let post = getPostAddress(searchTerm, true);
  let action = 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaAdreca';
  ajaxCall('Address', post, action, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements);
}

/**
 *
 * @param {*} type
 * @param {*} post
 * @param {*} action
 * @param {*} addCercaToponim
 * @param {*} zoomCoord
 * @param {*} handleLoadingLoc
 * @param {*} clearArElements
 * @desc funcio per fer la peticio http al servei de geocodificacio de l'icgc (carrers, pks i toponims)
 */
export function ajaxCall(type, post, action, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, closeCerca, isAvançada, infoPunt) {
  try {
    //obtenim la capçalera i fem la peticio post
    let header = getHeader();
    let post2 = '/ws/wss_1.0 HTTP/1.1';
    let host = 'www.icc.cat';

    $llamada = $j.ajax({
      type: 'POST',
      url: config.geocodificador,
      data: header + post,
      contentType: 'text/xml',
      dataType: 'xml',
      cache: false,
      beforeSend: function (xhr) {
        xhr.setRequestHeader('SOAPAction', action);
        xhr.setRequestHeader('POST', post2);
        xhr.setRequestHeader('Host', host);
        xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
      },
      success: function (data) {
        //quan obtenim la resposta, la processem en funcio del tipus
        if (type === 'PK') processPKResponse(data, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, closeCerca, isAvançada);
        else if (type === 'Address') processAddressResponse(data, zoomCoord, handleLoadingLoc, addCercaToponim, isAvançada, infoPunt);
        else if (type === 'Toponym') processToponymResponse(data, addCercaToponim, handleLoadingLoc, clearArElements, isAvançada);
      },
      failure: function () {
        //si falla la peticio, notifiquem l'usuari, traiem el spinner de loading i netegem l'array d'elements
        if (isAvançada) {
          if (type === 'PK') toast.error(getTranslatedKey('errorPK'), { autoClose: 4000, pauseOnHover: true });
          else if (type === 'Address') toast.error(getTranslatedKey('errorAddress'), { autoClose: 4000, pauseOnHover: true });
          else if (type === 'Toponym') toast.error(getTranslatedKey('errorElements'), { autoClose: 4000, pauseOnHover: true });
        }
        handleLoadingLoc(false);
        clearArElements();
      }
    });
  } catch (e) {
    //si falla la peticio, notifiquem l'usuari, traiem el spinner de loading i netegem l'array d'elements
    toast.error(e, { autoClose: 4000, pauseOnHover: true });
    handleLoadingLoc(false);
    clearArElements();
  }
}

/**
 *
 * @param {*} search
 * @desc funcio per obtenir el body de l'xml de la peticio de pks
 */
function getPostPK(search) {
  let pkResult = parserPK(search);
  if (pkResult.pk === '') {
    let arSearch = search.split(',');
    if (arSearch.length < 2) {
      arSearch = search.split(';');
    }
    pkResult.nomCar = arSearch[0].replace(/\s/g, '');
    pkResult.pk = '1';
  }
  return `<soapenv:Body><pk2 xmlns="http://ws.icc.cat/geocodificador/"><nomCarretera xmlns="">${pkResult.nomCar}</nomCarretera><KM xmlns="">${pkResult.pk}</KM></pk2></soapenv:Body></soapenv:Envelope>`;
}

/**
 *
 * @param {*} search
 * @desc funcio per obtenir el body de l'xml de la peticio d'adreces
 */
export function getPostAddress(search, param) {
  let post = '<soapenv:Body><adreca xmlns="http://ws.icc.cat/geocodificador/">';
  if (param) {
    let població, tipusVia, carrer, numPorta;
    [població, tipusVia, carrer, numPorta] = search.split(';');
    post += població !== 'Nom del municipi (opcional)' ? `<Poblacio  xmlns="">${població}</Poblacio>` : `<Poblacio  xmlns="">*</Poblacio>`;
    if (tipusVia !== 'undefined' && tipusVia !== 'Tipus de via (opcional)' && carrer)
      post += `<Via xmlns=""><Tipus>${tipusVia}</Tipus><Nom>${carrer}</Nom></Via>`;
    if ((tipusVia === 'undefined' || tipusVia === 'Tipus de via (opcional)') && carrer) post += `<Via xmlns=""><Nom>${carrer}</Nom></Via>`;
    post += numPorta !== undefined ? `<Portal  xmlns="">${numPorta}</Portal>` : `<Portal  xmlns=""></Portal>`;
  } else {
    let objectCerca = parserAddreess(search);

    if (objectCerca.Poblacio !== undefined) {
      post += `<Poblacio  xmlns="">${objectCerca.Poblacio.trim()}</Poblacio>`;
    } else {
      post += '<Poblacio  xmlns="">*</Poblacio>';
    }

    if (objectCerca.NomVia !== undefined) {
      post += '<Via xmlns="">';
      post += `<Nom>${objectCerca.NomVia.trim()}</Nom>`;
      post += '</Via>';
    }
    if (objectCerca.Portal !== undefined) {
      post += `<Portal  xmlns="">${objectCerca.Portal.trim()}</Portal>`;
    }
  }

  post += '</adreca></soapenv:Body></soapenv:Envelope>';
  return post;
}

/**
 *
 * @param {*} search
 * @desc funcio per obtenir el body de l'xml de la peticio de toponims
 */
function getPostToponym(search) {
  let comarca, municipi, tipus, nom;
  [comarca, municipi, tipus, nom] = search.split(';');
  let post = `<soapenv:Body><toponim xmlns="http://ws.icc.cat/geocodificador/">`;
  if (nom !== undefined) post += `<Nom xmlns="">${nom}</Nom>`;
  if (comarca && comarca !== 'Nom de la comarca (opcional)')
    post += nom !== undefined ? `<NomComarca>${comarca}</NomComarca>` : `<Nom xmlns="">${search}</Nom>`;
  if (municipi && municipi !== 'Nom del municipi (opcional)') post += `<NomMunicipi>${municipi}</NomMunicipi>`;
  if (tipus && tipus !== 'Tipus de topònim (opcional)') post += `<NomTipus>${tipus}</NomTipus>`;
  post += `</toponim></soapenv:Body></soapenv:Envelope>`;
  return post;
}
/**
 *
 * @param {*} search
 * @desc funcio per processar la resposta obtinguda a la peticio de pks
 */
function processPKResponse(data, addCercaToponim, zoomCoord, handleLoadingLoc, clearArElements, closeCerca, isAvançada) {
  let jsonContext = xmlToJson(data);
  let envelope = jsonContext['soapenv:Envelope'];
  let body = envelope['soapenv:Body'];
  if (body.pks.item !== undefined) {
    if (body.pks.item.length !== undefined) {
      //se ha devuelto más de un item
      $j.each(body.pks.item, async function (key, value) {
        body.pks.item.Nom = body.pks.item.nomCarretera + ', ' + body.pks.item.KM;
        await addCercaToponim(body.pks.item.Nom);
      });
    } else {
      let arCoord = [
        body.pks.item.coordenadesETRS89UTM.X['#text'].replace(/\s/g, ''),
        body.pks.item.coordenadesETRS89UTM.Y['#text'].replace(/\s/g, '')
      ];
      centerAtCoord(arCoord, zoomCoord);
      closeCerca();
    }
  } else {
    //no hi ha cap item
    if (isAvançada) {
      toast.warn(getTranslatedKey('warnNoPk'));
    }
    handleLoadingLoc(false);
    clearArElements();
  }
}

/**
 *
 * @param {*} search
 * @desc funcio per processar la resposta obtinguda a la peticio d'adreça
 */
function processAddressResponse(data, zoomCoord, handleLoadingLoc, addCercaToponim, isAvançada, infoPunt) {
  let jsonContext = xmlToJson(data);
  let envelope = jsonContext['soapenv:Envelope'];
  let body = envelope['soapenv:Body'];
  if (body.localitzacions !== undefined && body.localitzacions.item !== undefined) {
    if (envelope['soapenv:Body'].localitzacions.item.length !== undefined) {
      $j.each(envelope['soapenv:Body'].localitzacions.item, async function (key, value) {
        if (value.CoordenadesETRS89UTM?.X && value.CoordenadesETRS89UTM?.Y) {
          await addCercaToponim(value);
        } else {
          const element = await getLocalitzacioCoords(value);
          await addCercaToponim(element);
        }
      });
    } else {
      let arCoord = [
        body.localitzacions.item.CoordenadesETRS89UTM.X['#text'].replace(/\s/g, ''),
        body.localitzacions.item.CoordenadesETRS89UTM.Y['#text'].replace(/\s/g, '')
      ];
      centerAtCoord(arCoord, zoomCoord, infoPunt);
      handleLoadingLoc(false);
    }
  } else {
    if (isAvançada) {
      toast.warn(getTranslatedKey('warnNoAddress'), { autoClose: 4000, pauseOnHover: true });
    }

    handleLoadingLoc(false);
  }
}

const getLocalitzacioCoords = async (item) => {
  let body = '<soapenv:Body><adreca xmlns="http://ws.icc.cat/geocodificador/">';
  body += `<Poblacio xmlns="">${item.Adreca.Poblacio['#text']}</Poblacio> <via xmlns=""><id>${item.Adreca.Via.Id['#text']}</id></via><Portal  xmlns="">${item.Adreca.Portal['#text']}</Portal>`;
  body += '</adreca></soapenv:Body></soapenv:Envelope>';

  let action = 'http://www.icc.cat/geocodificador/ws/wss_1.0#localitzaAdreca';
  try {
    let header = getHeader();
    let post2 = '/ws/wss_1.0 HTTP/1.1';
    let host = 'www.icc.cat';
    return new Promise((resolve, reject) => {
      $j.ajax({
        type: 'POST',
        url: config.geocodificador,
        data: header + body,
        contentType: 'text/xml',
        dataType: 'xml',
        cache: false,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('SOAPAction', action);
          xhr.setRequestHeader('POST', post2);
          xhr.setRequestHeader('Host', host);
          xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
        },
        success: function (data) {
          let jsonContext = xmlToJson(data);
          let envelope = jsonContext['soapenv:Envelope'];
          let body = envelope['soapenv:Body'];
          let element = body.localitzacions.item;
          resolve(element);
        },
        failure: function () {
          reject(new Error('Failed to get localitzacio coords'));
          console.error('ha fallat');
        }
      });
    });
  } catch (e) {
    toast.error(e, { autoClose: 4000, pauseOnHover: true });
  }
};

/**
 *
 * @param {*} search
 * @desc funcio per processar la resposta obtinguda a la peticio de toponims
 */
async function processToponymResponse(data, addCercaToponim, handleLoadingLoc, clearArElements, isAvançada) {
  let jsonContext = xmlToJson(data);
  if (jsonContext !== undefined && jsonContext['soapenv:Envelope'] !== undefined) {
    let envelope = jsonContext['soapenv:Envelope'];
    if (envelope['soapenv:Body'].toponims.item !== undefined) {
      if (envelope['soapenv:Body'].toponims.item.length !== undefined) {
        $j.each(envelope['soapenv:Body'].toponims.item, async function (key, value) {
          await addCercaToponim(value);
        });
      } else await addCercaToponim(envelope['soapenv:Body'].toponims.item);
    } else {
      if (isAvançada) {
        toast.warn(getTranslatedKey('warnNoTopo'));
      }
      handleLoadingLoc(false);
      clearArElements();
    }
  } else {
    handleLoadingLoc(false);
    clearArElements();
  }
}

/**
 *
 * @param {*} search
 * @desc funcio per obtenir el tipus de cerca que s'ha de fer
 */
function getCercaValue(search) {
  let value = $j('.optionSelected').attr('id');
  if (value === undefined) value = 0;
  if (value === 0) {
    // adreça
    let addr = parserAddreess(search);

    if (addr.Poblacio !== undefined && !IsNumeric(addr.Poblacio)) {
      value = 3;
    } else {
      let pkRes = parserPK(search);
      if (pkRes.pk !== '' && IsNumeric(pkRes.pk)) {
        value = 4;
      } else value = 100;
    }
  }
  return value;
}

/**
 *
 * @desc funcio per obtenir el header de la petició http de geocodificació
 */
function getHeader() {
  let sUsrname = 'dptop';
  let fPwd = '5eAEHUcQRkwzN2TCL9t9pk7S2GE=';
  let header = `<soapenv:Envelope soapenv:encodingStyle='http://schemas.xmlsoap.org/soap/encoding/' xmlns:soapenv='http://schemas.xmlsoap.org/soap/envelope/' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:SOAP-ENC='http://schemas.xmlsoap.org/soap/encoding/' xmlns:si='http://soapinterop.org/xsd' xmlns:tns='urn:idecwsdl'><soapenv:Header><wsse:Security xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" soapenv:mustUnderstand="1"><wsse:UsernameToken xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd" wsu:Id="UsernameToken-32685187"><wsse:Username>${sUsrname}</wsse:Username><wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordDigest">${fPwd}</wsse:Password><wsse:Nonce></wsse:Nonce><wsu:Created></wsu:Created></wsse:UsernameToken></wsse:Security></soapenv:Header>`;
  return header;
}

/**
 *
 * @param {*} search
 * @desc Función encargada de parsear un pk en el input de la Cerca a un objeto PK
 */
function parserPK(search) {
  let numberRegex = /^[+-]?\d+(\.\d+)?([eE][+-]?\d+)?$/;
  let arSearch = search.split(',');
  if (arSearch.length < 2) {
    arSearch = search.split(';');
  }
  if (arSearch.length < 2) {
    arSearch = search.split('KM');
  }
  if (arSearch.length < 2) {
    arSearch = search.split('PK');
  }
  let nomCar = '';
  let pk = '';

  if (arSearch.length === 2) {
    if (numberRegex.test(arSearch[0].replace(/\s/g, '')) && numberRegex.test(arSearch[1].replace(/\s/g, ''))) {
      nomCar = arSearch[0].replace(/\s/g, '');
      pk = arSearch[1].replace(/\s/g, '');
    } else if (numberRegex.test(arSearch[0].replace(/\s/g, ''))) {
      nomCar = arSearch[1].replace(/\s/g, '');
      pk = arSearch[0].replace(/\s/g, '');
    } else if (numberRegex.test(arSearch[1].replace(/\s/g, ''))) {
      nomCar = arSearch[0].replace(/\s/g, '');
      pk = arSearch[1].replace(/\s/g, '');
    } else {
      nomCar = arSearch[0].replace(/\s/g, '');
      pk = '1';
    }
  }

  let objectReturn = {
    nomCar: nomCar,
    pk: pk
  };
  return objectReturn;
}

/**
 * @param {*} searchString
 * @returns
 * @desc Función encargada de parsear una dirección en el input de la Cerca a un objeto Address
 */
function parserAddreess(searchString) {
  let objectCerca = {};

  objectCerca.NomVia = '';
  objectCerca.Portal = '';
  objectCerca.Poblacio = '';
  let arString;

  if (searchString.split(',').length === 1 && searchString.split(';').length === 1) {
    arString = searchString.split(' ');
    if (arString.length === 1) {
      // si només hi ha una paraula a la cerca, la definim con el nom de la via
      objectCerca.NomVia = searchString;
    } else {
      // si n'hi han més resultats, obtenim el nom de la via i el portal
      let resultatparserStreet = parserStreet(arString);

      objectCerca.NomVia = resultatparserStreet.NomVia;
      objectCerca.Portal = resultatparserStreet.Portal;
    }
  } else {
    // si l'adreça está separada per una coma, parsejem la primera part com a nom de la via i portal,
    // i la segona part com el portal o la població
    if (searchString.split(',').length === 2) {
      arString = searchString.split(',');

      let direccio0 = arString[0];
      let direccio1 = arString[1];

      let resultatparserStreet = parserStreet(direccio0.split(' '));

      objectCerca.NomVia = resultatparserStreet.NomVia;
      objectCerca.Portal = resultatparserStreet.Portal;

      if (IsNumeric(direccio1)) {
        objectCerca.Portal = direccio1;
      } else {
        objectCerca.Poblacio = direccio1;
      }
    } else if (searchString.split(',').length === 3) {
      // si l'adreça té dos comes, parsejem la primera part com a nom de la via y portal,
      // la segona part com el portal i la tercera com la població
      // si el tercer camp és el país, s'obvia.
      arString = searchString.split(',');

      let resultatparserStreet = parserStreet(arString[0].split(' '));
      objectCerca.NomVia = resultatparserStreet.NomVia;
      objectCerca.Portal = resultatparserStreet.Portal;

      if (IsNumeric(arString[1].replace(/\s/g, ''))) {
        objectCerca.Portal = arString[1].replace(/\s/g, '');
        objectCerca.Poblacio = arString[2].replace(/\s/g, '');
      } else {
        objectCerca.Poblacio = arString[1].replace(/\s/g, '');
        // El tercer camp s'obvia(Pais¿?)
      }
    } else if (searchString.split(';').length === 2) {
      // si l'adreça está separada per un punt i coma, parsejem la primera part com a nom de la vía i portal,
      // i la segona part com el portal o la població
      arString = searchString.split(';');

      let string0 = arString[0];
      let string1 = arString[1];

      let resultatparserStreet = parserStreet(string0.split(' '));

      objectCerca.NomVia = resultatparserStreet.NomVia;
      objectCerca.Portal = resultatparserStreet.Portal;

      if (IsNumeric(string1)) {
        objectCerca.Portal = string1;
      } else {
        objectCerca.Poblacio = string1;
      }
    } else if (searchString.split(';').length === 3) {
      // si l'adreça té dos comes, parsejem la primera part com a nom de la via y portal,
      // la segona part com el portal i la tercera com la població
      // si el tercer camp és el país, s'obvia.
      arString = searchString.split(';');

      let resultatparserStreet = parserStreet(arString[0].split(' '));
      objectCerca.NomVia = resultatparserStreet.NomVia;
      objectCerca.Portal = resultatparserStreet.Portal;

      if (IsNumeric(arString[1].replace(/\s/g, ''))) {
        objectCerca.Portal = arString[1].replace(/\s/g, '');
        objectCerca.Poblacio = arString[2].replace(/\s/g, '');
      } else {
        objectCerca.Poblacio = arString[1].replace(/\s/g, '');
        // El tercer camp s'obvia(Pais¿?)
      }
    }
  }

  return objectCerca;
}

/**
 * @param {*} carrerStringArray
 * @desc Función encargada de parsear una calle mediante el input de la Cerca
 */
function parserStreet(carrerStringArray) {
  let objReturn = {};
  objReturn.NomVia = '';
  objReturn.Portal = '';

  let ultEsPortal = false;
  let expNumber = /[0-9]+\-[0-9]+/g;
  if (IsNumeric(carrerStringArray[carrerStringArray.length - 1].replace(/\./g, ' '))) {
    objReturn.Portal = carrerStringArray[carrerStringArray.length - 1].replace(/\./g, ' ');
    ultEsPortal = true;
  } else if (expNumber.test(carrerStringArray[carrerStringArray.length - 1].replace(/\s/g, ''))) {
    objReturn.Portal = carrerStringArray[carrerStringArray.length - 1].split('-')[0];
    ultEsPortal = true;
  }
  let carrer = '';
  for (let i = 0; i < carrerStringArray.length - 1; i++) {
    carrer = carrer + ' ' + carrerStringArray[i];
  }
  if (!ultEsPortal) {
    carrer = carrer + ' ' + carrerStringArray[carrerStringArray.length - 1];
  }
  objReturn.NomVia = carrer;

  return objReturn;
}

/**
 * @param {*} arCoord
 * @desc Función encargada de hacer zoom en el mapa con las coordenadas de la cerca
 */
function centerAtCoord(arCoord, zoomCoord, infoPunt) {
  if (
    parseFloat(arCoord[0].replace(/\s/g, '')) <= 536000 &&
    parseFloat(arCoord[0].replace(/\s/g, '')) >= 258000 &&
    parseFloat(arCoord[1].replace(/\s/g, '')) <= 4752000 &&
    parseFloat(arCoord[1].replace(/\s/g, '')) >= 4485000
  ) {
    // ETRS89
    zoomCoord(arCoord, false, true, undefined, undefined, undefined, infoPunt);
  } else if (
    parseFloat(arCoord[0].replace(/\s/g, '')) <= 180 &&
    parseFloat(arCoord[0].replace(/\s/g, '')) >= -180 &&
    parseFloat(arCoord[1].replace(/\s/g, '')) <= 90 &&
    parseFloat(arCoord[1].replace(/\s/g, '')) >= -90
  ) {
    // LatLon
    let location = [arCoord[1], arCoord[0]];
    zoomCoord(location, false, false, undefined, undefined, undefined, infoPunt);
  }
}

/**
 * @desc wfs para obtener las features del elemento al hacerle click
 */
export function cercaLayerElements(id, name, coords, obrirInfoSolr, arrayLayers) {
  const layer = arrayLayers.find((layer) => layer.getName() === name);
  let or = layer?.getOnlineResource();
  let parsedID = name + '.' + id;
  const properties = layer
    ?.getProperties()
    .map((prop) => prop.name)
    .concat(layer.getExtension().Geometry)
    .join(',');

  let url = `${or}?service=wfs&version=${config.version_2_0}&request=GetFeature&outputFormat=application/json&srsName=${config.EPSG_mapa}&featureID=${parsedID}&propertyName=${properties}`;

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=Windows-1252',
      'Access-Control-Allow-Origin': '*'
    }
  })
    .then((resp) => {
      return resp.text();
    })
    .then(async (data) => {
      let fc = new GeoJSON().readFeatures(data);
      obrirInfoSolr(fc, name, coords);
    })
    .catch(() => {
      toast.error(getTranslatedKey('error_cercaElement'), { autoClose: 4000, pauseOnHover: true });
    });
}

export async function cercaCadastre(ref, goToCadastre) {
  let ext = `Provincia=&Municipio=&SRS=25831&RC=${ref}`;
  let url = '/proxyCadastre.php?' + ext;

  try {
    const resp = await fetch(url);
    const xmlDoc = await resp.text();
    const parser = new DOMParser();
    const xmlDocParsed = parser.parseFromString(xmlDoc, 'text/xml');
    const error = xmlDocParsed.getElementsByTagName('err');
    if (error.length > 0) {
      goToCadastre('error');
    } else {
      const x = Number(xmlDocParsed.getElementsByTagName('xcen')[0].textContent) || 'A';
      const y = Number(xmlDocParsed.getElementsByTagName('ycen')[0].textContent) || 'A';
      goToCadastre([x, y]);
    }
  } catch (error) {
    toast.error(error, { autoClose: 4000, pauseOnHover: true });
  }
}
